import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'panoramaShow',
    templateUrl:'panoramaShow.html'
})
export class PanoramaShowActionComponent extends BaseActionComponent{

  public dataList;
  public media
  public level=1;
  public text;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'panoramaShow',param:{}}
    }
  
    action.param.url=this.media.url;
    action.param.fullUrl=this.media.fullUrl
    action.param.dx=0.5;
    action.param.dy=0.5;
    action.param.dz=0.5;
    action.param.space=this.media.id;
    action.param.room=this._appData.room.id;  
  }
  public gotoLink(item){
    window.open(item.url, '_blank');
  }
  public selectItem(item) {
    this.media=null
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id == item.id) {
          this.dataList[i].selected = true;
          this.media=item
      }
      else {
          this.dataList[i].selected = false;
      }
    }
  }  
  public reloadLocalPacks(){
    let list=[]


      if (this._appData.room.backgroundPhoto) {
        this._appData.room.backgroundPhoto.forEach(v=>{
          let image={
            url:v.psma,
            fullUrl:v.pbig,
            id:v.id
          }
          list.push(image);
        })
      }
    
    this.dataList = []
      list.forEach(ic => {
        ic.url = ic.url
        ic.selected = false        
        if (this.action.param) {
          if ((this.action.param.url) == ic.url) {
            ic.selected = true;
            this.media=ic
          }
        }
        this.dataList.push(ic);
      })  
    
    
  }

  public childrenReloadData(){
    let list=[]
    let split=null
    if (this.action.param && this.action.param.url){
      split=this.action.param.url.split('-')
      if (split.length>0 && split[0]=='pack'){
        this.selectedPack=this._appData.room.packs[split[1]]
      }
    }
    this.reloadLocalPacks();

  

  }

    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/panoramaShow.ts